import { Box } from "@mui/material";
import {
  gridColumnsTotalWidthSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import { useEffect, useRef, useState } from "react";

/** 表が縦に長い場合も、先頭から横方向へ移動できる Toolbar 用バー */
export const DataGridTopScrollbar: React.FC = () => {
  const apiRef = useGridApiContext();
  const contentWidth = useGridSelector(apiRef, gridColumnsTotalWidthSelector);
  const scrollbarRef = useRef<HTMLDivElement>(null);
  const [viewportWidth, setViewportWidth] = useState(0);

  useEffect(() => {
    const updateViewportWidth = (): void => {
      setViewportWidth(
        apiRef.current.getRootDimensions()?.viewportInnerSize.width ?? 0
      );
    };
    updateViewportWidth();
    const unsubscribeSize = apiRef.current.subscribeEvent(
      "viewportInnerSizeChange",
      updateViewportWidth
    );
    const unsubscribeScroll = apiRef.current.subscribeEvent(
      "rowsScroll",
      ({ left }) => {
        if (scrollbarRef.current) scrollbarRef.current.scrollLeft = left;
      }
    );
    return () => {
      unsubscribeSize();
      unsubscribeScroll();
    };
  }, [apiRef]);

  useEffect(() => {
    if (scrollbarRef.current)
      scrollbarRef.current.scrollLeft = apiRef.current.getScrollPosition().left;
  }, [apiRef, contentWidth, viewportWidth]);

  return (
    <Box
      ref={scrollbarRef}
      role="region"
      aria-label="一覧の横スクロール"
      tabIndex={0}
      onScroll={(event) => {
        const left = event.currentTarget.scrollLeft;
        if (left !== apiRef.current.getScrollPosition().left)
          apiRef.current.scroll({ left });
      }}
      sx={{
        display:
          viewportWidth > 0 && contentWidth > viewportWidth ? "block" : "none",
        width: viewportWidth,
        // ツールバー下側の余白に収め、スクロール領域で下余白だけが増えるのを防ぐ。
        position: "absolute",
        left: 0,
        bottom: 0,
        height: 16,
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      <Box sx={{ width: contentWidth, height: 1 }} />
    </Box>
  );
};
